export class SeedingCriteriaType {
    public id: string;
    public name: string;
    public isSortOrderAscending: boolean = false;

    // Consts are a copy of the SeedingCriteriaType enum defined in the floarena-api
    public static RECORD: string = 'record';

    public static YES_NO: string = 'yes-no';

    public static NUMERIC: string = 'numeric';

    public static isRecord(id: string = null): boolean {
        return id === this.RECORD;
    }

    public static TYPES: SeedingCriteriaType[] = [
        new SeedingCriteriaType(SeedingCriteriaType.NUMERIC, 'Numeric', true),
        new SeedingCriteriaType(SeedingCriteriaType.YES_NO, 'Yes/No', false),
        new SeedingCriteriaType(SeedingCriteriaType.RECORD, 'Record', false),
    ];

    constructor(id: string = null, name: string = null, isSortOrderAscending: boolean = false) {
        this.id = id;
        this.name = name;
        this.isSortOrderAscending = isSortOrderAscending;

        if (id && !name) {
            const type: SeedingCriteriaType = SeedingCriteriaType.TYPES.find((type) => type.id === id);
            this.name = type.name;
            this.isSortOrderAscending = type.isSortOrderAscending;
        }
    }

    public isRecord(): boolean {
        return SeedingCriteriaType.isRecord(this.id);
    }

    public isYesNo(): boolean {
        return this.id === SeedingCriteriaType.YES_NO;
    }

    public isNumeric(): boolean {
        return this.id === SeedingCriteriaType.NUMERIC;
    }

    public clone(): SeedingCriteriaType {
        return new SeedingCriteriaType(this.id, this.name, this.isSortOrderAscending);
    }
}
